import React from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, Team } from "..";

export const TeamMunch = () => {
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const aboutDetails = useStore((state) => state.aboutDetails);

  const overlay = {
    where: "aboutMunch",
    title: "In Memory of Munch",
    caption: "Forever in our hearts. 2007-2024. 🐾",
  };
  const info = {
    routes: {
      Home: "/",
      "Todo's Team": getLink(pathTitles.MEETTHETEAM),
      "In Memory of Munch": getLink(pathTitles.MEETMUNCH),
    },
    body: aboutDetails.MUNCH.body,
  };
  return (
    <>
      <SEO
        title="In Memory of Munch"
        description="A tribute to Munch, 2007–2024. Remembering a beloved member of the Todo's Translator family."
        path="/meet-the-trainer/in-memory-of-munch"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <Team info={info} />
        </>
      )}
    </>
  );
};
